// extracted by mini-css-extract-plugin
export default {"icon":"Favorite_icon__gcp7q","icon_active":"Favorite_icon_active__yL4WN"};